var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-gap-results" },
    [
      _c("h3", { staticClass: "viq-gap-results__title" }, [
        _vm._v("Gap Analysis Results"),
      ]),
      _vm._v(" "),
      _vm.isStreaming
        ? _c("div", { staticClass: "viq-gap-results__loading" }, [
            _c("span", { staticClass: "viq-gap-results__spinner" }),
            _vm._v("\n    Analysing gaps...\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.parsedResults
        ? [
            _vm.parsedResults.summary
              ? _c("div", { staticClass: "viq-gap-results__summary" }, [
                  _c("h4", [_vm._v("Summary")]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.parsedResults.summary))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.gapItems.length > 0
              ? _c(
                  "div",
                  { staticClass: "viq-gap-results__items" },
                  _vm._l(_vm.gapItems, function (item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "viq-gap-results__item" },
                      [
                        _c(
                          "div",
                          { staticClass: "viq-gap-results__item-header" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "viq-gap-results__severity",
                                class:
                                  "viq-gap-results__severity--" +
                                  (item.severity || "medium").toLowerCase(),
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.severity || "Medium") +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h4",
                              { staticClass: "viq-gap-results__item-title" },
                              [_vm._v(_vm._s(item.title || item.gap))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        item.description
                          ? _c(
                              "p",
                              { staticClass: "viq-gap-results__item-desc" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.description) +
                                    "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.recommendation
                          ? _c(
                              "div",
                              {
                                staticClass: "viq-gap-results__recommendation",
                              },
                              [
                                _c("strong", [_vm._v("Recommendation:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(item.recommendation) +
                                    "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.parsedResults.content && !_vm.gapItems.length
              ? _c("div", {
                  staticClass: "viq-gap-results__content",
                  domProps: { innerHTML: _vm._s(_vm.renderedContent) },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStreaming
        ? _c(
            "div",
            { staticClass: "viq-gap-results__actions" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportPdf } },
                [_vm._v("Export as PDF")]
              ),
              _vm._v(" "),
              _vm.$config.features && _vm.$config.features.viqShare
                ? _c("el-button", { on: { click: _vm.share } }, [
                    _vm._v("Save & Share"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.newAnalysis } }, [
                _vm._v("New Analysis"),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }